import { useEffect,useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from '../../../config/Translations';

export default function TicketAnnouncer() {
  const quantities = useSelector(state => state.ticketPicker.quantities);
  const levels = useSelector(state => state.priceLevel.levels);
  const lastModifiedLevelId = useSelector(state => state.ticketPicker.lastModifiedLevelId);
  const liveRegionRef = useRef(null);
  const timeoutRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const levelName = levels?.[lastModifiedLevelId]?.name;
    if (levelName) {
      const quantity = quantities[lastModifiedLevelId];
      announceQuantityChange(levelName, quantity);
    }
  }, [quantities, levels, lastModifiedLevelId]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      ref={liveRegionRef}
      className="sr-only" //comment this row for test
    />
  );

  function announceQuantityChange(level_name, quantity_x) {
    const quantity = quantity_x || 0;
    if (liveRegionRef.current) {
      liveRegionRef.current.textContent = '';
      timeoutRef.current = setTimeout(() => {
        liveRegionRef.current.textContent = t('checkout__level_name_quantity_x',{level_name,quantity}) ;
      }, 50);
    }
  }
}

